import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create(
{
    page: {
        display: 'flex',
    },

    iframe: {
        marginTop: 32,
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
    },

    title: {
        fontSize: 24,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700', 
        marginTop: 54
    }
});